export type PillTone =
	| "active"
	| "awaiting"
	| "done"
	| "risk"
	| "neutral"
	| "info";

export interface PillProps {
	tone?: PillTone;
	dot?: boolean;
	children: React.ReactNode;
	className?: string;
	style?: React.CSSProperties;
}

const toneMap: Record<PillTone, { color: string; bg: string }> = {
	active: {
		color: "var(--color-dashboard-accent-dark)",
		bg: "color-mix(in srgb, var(--color-dashboard-accent) 12%, transparent)",
	},
	awaiting: {
		color: "var(--color-dashboard-pill-awaiting)",
		bg: "var(--color-dashboard-pill-awaiting-bg)",
	},
	done: {
		color: "var(--color-dashboard-pill-done)",
		bg: "var(--color-dashboard-pill-done-bg)",
	},
	risk: {
		color: "var(--color-dashboard-pill-risk)",
		bg: "var(--color-dashboard-pill-risk-bg)",
	},
	neutral: {
		color: "var(--color-dashboard-muted)",
		bg: "var(--color-dashboard-divider)",
	},
	info: {
		color: "var(--color-dashboard-pill-info)",
		bg: "var(--color-dashboard-pill-info-bg)",
	},
};

export function Pill({
	tone = "neutral",
	dot = false,
	children,
	className,
	style,
}: PillProps) {
	const { color, bg } = toneMap[tone];

	return (
		<span
			className={className}
			style={{
				display: "inline-flex",
				alignItems: "center",
				gap: 6,
				height: 24,
				paddingLeft: 10,
				paddingRight: 10,
				fontSize: 12,
				fontFamily: "var(--font-body)",
				fontWeight: 500,
				color,
				background: bg,
				borderRadius: 12,
				...style,
			}}
		>
			{dot && (
				<span
					style={{
						width: 6,
						height: 6,
						borderRadius: "50%",
						background: color,
						flexShrink: 0,
					}}
				/>
			)}
			{children}
		</span>
	);
}
